@let announcement = this.announcement();

@if (announcement) {
  <tds-banner
    roleType="banner"
    icon="info"
    [header]="announcement.titleKey | translate"
    [subheader]="announcement.messageKey | translate"
    (tdsClose)="onClose()"
  >
    @if (hasAction()) {
      <tds-link slot="actions" standalone>
        <a
          class="announcement-banner__link"
          [href]="announcement.url"
          target="_blank"
          rel="noopener noreferrer"
          (click)="onLinkClick()"
        >
          {{ announcement.linkTextKey | translate }}
        </a>
      </tds-link>
    }
  </tds-banner>
}
